import React from 'react'
import { color, TZABrandGuidelines } from '@my/util'
import { XStack, YStack, SimpleText, ActionButton, Image, PriorityBadge } from '@my/ui'
import { FinancialReviewHeading } from '../../../../components/index'
import assets from '../../../../assets/images/index'

// Reusable component for the header (with the recommendation title and priority)
const RecommendationHeader: React.FC<RecommendationHeaderProps> = ({ title, priority }) => (
  <XStack mb="$2" gap={20} justifyContent="space-between">
    <XStack>
      <YStack>
        <FinancialReviewHeading
          img={assets.recommendation}
          //imageStyle={{ style: { height: 26, width: 26 } }}
          gradientStyle={{ height: 45, width: 45 }}
        />
      </YStack>
      <YStack justifyContent="space-between" height={40}>
        <SimpleText fontWeight="bold" color={color.grey} fontSize={15}>
          {title}
        </SimpleText>
        <SimpleText fontWeight="500" fontSize={13} color={color.lightRed}>
          {priority}
        </SimpleText>
      </YStack>
    </XStack>
    <PriorityBadge priority={priority} />
  </XStack>
)



// Reusable component for the strategy section
const StrategySection: React.FC<StrategySectionProps> = ({ strategy }) => (
  <XStack mb="$2">
    <Image
      source={assets.strategy}
      style={{ height: 14, width: 14, marginRight: 8, marginTop: 2 }}
      tintColor={color.lightGrey}
    />
    <SimpleText fontWeight="600" maxWidth={280} fontSize={16} color={color.grey}>
      Strategy: {strategy}
    </SimpleText>
  </XStack>
)

// Reusable component for the action section (Immediate Action)
const ActionSection: React.FC<ActionSectionProps> = ({ title, immediateAction, monthlyImpact }) => (
  <XStack mb="$2">
    <Image src={assets.clock} style={{ height: 12, width: 12, marginRight: 8, marginTop: 6 }} />
    <YStack gap={5} width={'100%'}>
      <SimpleText fontSize={15} fontWeight="500" color={color.black}>
        {title}
      </SimpleText>
      <SimpleText color={color.darkGrey} /* maxWidth={280} */ fontWeight="400" fontSize={15}>
        {immediateAction.action}
      </SimpleText>
      <SimpleText fontSize={15} fontWeight="500" color={color.black}>
        Target
      </SimpleText>
      <SimpleText color={color.darkGrey} /* maxWidth={280} */ fontWeight="400" fontSize={15}>
        {immediateAction.target}
      </SimpleText>
      <SimpleText fontSize={15} fontWeight="500" color={color.black}>
        Timeline
      </SimpleText>
      <SimpleText color={color.darkGrey} /* maxWidth={280} */ fontWeight="400" fontSize={15}>
        {immediateAction.timeline} 
      </SimpleText>
      {monthlyImpact ? <>
        <SimpleText fontSize={15} fontWeight="500" color={color.black}>
          Short-Term Impact
        </SimpleText>
        <SimpleText color={TZABrandGuidelines.colorsMap.secondarySalmon} /* maxWidth={280} */ fontSize={14} fontWeight="700" mb="$2">
          {monthlyImpact}
        </SimpleText>
      </> : null}
    </YStack>
  </XStack>
)

// Reusable component for the long-term impact section
const LongTermImpactSection: React.FC<LongTermImpactSectionProps> = ({ impact, savings, title, impactColor }) => (
  <XStack>
    <Image src={assets.impact} style={{ height: 13, width: 13, marginRight: 8, marginTop: 6 }} />
    <YStack gap={5} width={'100%'}>
      <SimpleText fontSize={15} fontWeight="600" color={impactColor as any}>
        {title}
      </SimpleText>
      {/* <SimpleText backgroundColor={color.lightGrey} maxWidth={280} fontWeight="700" fontSize={15}>
        {impact}
      </SimpleText> */}
      <SimpleText color={color.darkGrey as any} /* maxWidth={280} */ fontWeight="400" fontSize={15} mb="$2">
        {savings}
      </SimpleText>
    </YStack>
  </XStack>
)

// Reusable component for the footer section (Buttons)
const FooterSection: React.FC<{ onImplement: () => void }> = ({ onImplement }) => (
  <YStack flexDirection="row" gap={30}>
    <ActionButton
      size="$4"
      flex={1}
      backgroundColor={color.tzaGreen}
      onPress={onImplement}
      color={color.grey}
      fontSize={16}
      fontWeight="600"
    >
      Implement
    </ActionButton>
    <ActionButton
      size="$4"
      flex={1}
      variant="outlined"
      borderColor={color.blue}
      color={color.blue}
      fontSize={16}
      fontWeight="600"
    >
      Learn More
    </ActionButton>
  </YStack>
)

// Main RecommendationCardItem component
export const RecommendationCardItem: React.FC<RecommendationCardItemProps> = (props) => {
  const { title, priority, effort, immediateAction, monthlyImpact, longTermImpact, onImplement, strategy, justBody } = props;
  const body = <YStack gap={20} paddingRight={15}>
    {justBody ? null : <StrategySection strategy={strategy} />}
    <ActionSection title="Immediate Action" immediateAction={immediateAction} monthlyImpact={''} />
    <LongTermImpactSection title={'Short-Term Impact'} impactColor={TZABrandGuidelines.colorsMap.secondarySalmon} impact={''} savings={monthlyImpact} />
    <LongTermImpactSection title={'Long-Term Impact'} impactColor={TZABrandGuidelines.colorsMap.secondaryBlue} impact={''} savings={longTermImpact} />
  </YStack>
  return justBody ? body : (
    <YStack
      padding="$4"
      borderWidth={1}
      borderColor="#e2e2e2"
      borderRadius="$4"
      shadowColor="#aaa"
      shadowRadius={4}
      marginBottom="$4"
      backgroundColor="white"
      gap={20}
      justifyContent="space-between"
      minHeight={125}
    >
      {/* Header Section */}
      <RecommendationHeader title={title} priority={priority} />

      {/* Body Section */}
      {body}

      {/* Footer Section */}
      {/* <FooterSection onImplement={onImplement} /> */}
    </YStack>
  )
}
